import React, { useMemo, useState } from "react";
import { Task, useTasksContext } from "../../../contexts/TasksContext";
import TaskProgressBar from "./FileSelector/FileUpload/TaskProgressBar";
import SummaryModal from "./FileSelector/SummaryModalNew";
import styles from "./Tasks.module.scss";

export interface TasksProps {
  setSelectedMenu: (selectedMenu: number) => void;
  page: string;
  selectedMode: string;
  setSummaryView: (summaryView: {
    viewed: boolean;
    doc: string;
    summary: string;
  }) => void;
  setSelectedMode: (selectedMode: string) => void;
  /** Aligné sur le DevMode du chat : affiche « Last activity » sur les cartes. */
  devMode?: boolean;
}

function Tasks({
  setSelectedMenu,
  page,
  selectedMode,
  setSummaryView,
  setSelectedMode,
  devMode = false,
}: TasksProps) {
    const { tasks } = useTasksContext();
    const [showSummaryModal, setShowSummaryModal] = useState({task: null, show: false});

    const sortedTasks = useMemo(
      () =>
        [...tasks].sort((a, b) => {
          if (!a.createdAt) return 1;
          if (!b.createdAt) return -1;
          return b.createdAt - a.createdAt;
        }),
      [tasks]
    );

    const openSummary = (task: Task) => {
        setShowSummaryModal({task: task, show: true});
    }

    return (
        <div className={styles.tasksPage}>
          <div className={styles.tasksList}>
            {sortedTasks.length === 0 ? (
              <div className={styles.tasksEmpty}>
                No tasks yet.
              </div>
            ) : (
              sortedTasks.map((task) => (
                <TaskProgressBar
                  key={task.id}
                  task={task}
                  setSelectedMenu={setSelectedMenu}
                  setSelectedMode={setSelectedMode}
                  openSummary={() => openSummary(task)}
                  showLastActivity={devMode}
                />
              ))
            )}
          </div>
          <SummaryModal
            showSummaryModal={showSummaryModal.show}
            setShowSummaryModal={(value: boolean) =>
              setShowSummaryModal({ task: null, show: value })
            }
            fileName={showSummaryModal?.task?.file?.filename}
            taskType={showSummaryModal?.task?.type}
            page={page}
            mode={showSummaryModal?.task?.mode}
            selectedMode={selectedMode}
            setSummaryView={setSummaryView}
            setSelectedMenu={setSelectedMenu}
          />
        </div>
    );
}

export default Tasks;
